import {getDashboardPeriods} from 'services/utils/misc'

const {today, pastWeek, monthAgo, past90Days} =
    getDashboardPeriods('D MMMM, YYYY')

export const periods = [
    {key: 'past_week', activitiesFrom: pastWeek, activitiesTo: today},
    {key: 'past_30_days', activitiesFrom: monthAgo, activitiesTo: today},
    {key: 'past_90_days', activitiesFrom: past90Days, activitiesTo: today},
]

export const dashboardStatuses = ['pending', 'done', 'expired']

export const statusesMap = {
    reqDones: 'done',
    reqCreats: 'create',
    reqExpired: 'expired',
}
